// Generated by scripts/write-horror-race-replay-fixtures.ts.
// Do not edit manually.

import type { HorrorRaceReplayEventType } from "./event-adapter";

export interface HorrorRaceReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface HorrorRaceReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: HorrorRaceReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface HorrorRaceReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "horror-race";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly seed: number;
  readonly players: readonly HorrorRaceReplayFixturePlayer[];
  readonly events: readonly HorrorRaceReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const HORROR_RACE_REPLAY_FIXTURES: Record<
  string,
  HorrorRaceReplayFixture
> = {
  "simple-3p-live": {
    schemaVersion: 1,
    gameType: "horror-race",
    scenario: "simple-3p-live",
    source: "generated",
    capturedAt: "2026-06-02T00:00:00.000Z",
    seed: 2026052603,
    players: [
      {
        id: "p1",
        name: "P1",
        role: "host",
      },
      {
        id: "p2",
        name: "P2",
        role: "player",
      },
      {
        id: "p3",
        name: "P3",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            phase: "SETUP_CHARACTER_SELECTION",
            config: {
              playerCount: 3,
              trackLength: 12,
              totalRaces: 1,
              coinsPerCharacter: 5,
            },
            raceNumber: 1,
            round: 1,
            players: [
              {
                id: "p1",
                name: "P1",
                hand: ["VAMPIRE", "JIANGSHI", "GUMIHO", "MUMMY", "ZOMBIE"],
                secretSelection: null,
                hasRevealed: false,
                hasConfirmedRecap: false,
                hasConfirmedRoundRecap: false,
              },
              {
                id: "p2",
                name: "P2",
                hand: ["VAMPIRE", "JIANGSHI", "GUMIHO", "MUMMY", "ZOMBIE"],
                secretSelection: null,
                hasRevealed: false,
                hasConfirmedRecap: false,
                hasConfirmedRoundRecap: false,
              },
              {
                id: "p3",
                name: "P3",
                hand: ["VAMPIRE", "JIANGSHI", "GUMIHO", "MUMMY", "ZOMBIE"],
                secretSelection: null,
                hasRevealed: false,
                hasConfirmedRecap: false,
                hasConfirmedRoundRecap: false,
              },
            ],
            turnOrder: [0, 1, 2],
            currentTurnIndex: 0,
            drawPass: 1,
            characterPositions: {
              VAMPIRE: 0,
              JIANGSHI: 0,
              GUMIHO: 0,
              MUMMY: 0,
              ZOMBIE: 0,
            },
            coinPool: [],
            drawnCoins: [],
            zones: {
              "1": [],
              "2": [],
              "4": [],
            },
            forfeitPlayerIndex: null,
            hasForfeitThisRound: false,
            raceResults: [],
            garnets: {
              p1: 0,
              p2: 0,
              p3: 0,
            },
            selectionsComplete: 0,
            hostPlayerId: "p1",
            roundResolution: null,
            currentRaceDrawHistory: [],
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "select_characters",
        userId: "p1",
        payload: {
          playerId: "p1",
          characters: ["VAMPIRE", "GUMIHO"],
        },
      },
      {
        sequenceNumber: 3,
        eventType: "select_characters",
        userId: "p2",
        payload: {
          playerId: "p2",
          characters: ["JIANGSHI", "MUMMY"],
        },
      },
      {
        sequenceNumber: 4,
        eventType: "select_characters",
        userId: "p3",
        payload: {
          playerId: "p3",
          characters: ["ZOMBIE", "VAMPIRE"],
        },
      },
      {
        sequenceNumber: 5,
        eventType: "request_draw",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 6,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027063603,
        },
      },
      {
        sequenceNumber: 7,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 8,
        eventType: "place_coins",
        userId: "p1",
        payload: {
          playerId: "p1",
          placements: [
            {
              character: "GUMIHO",
              zone: 1,
            },
            {
              character: "JIANGSHI",
              zone: 1,
            },
            {
              character: "JIANGSHI",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 9,
        eventType: "request_draw",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 10,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027063703,
        },
      },
      {
        sequenceNumber: 11,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 12,
        eventType: "place_coins",
        userId: "p2",
        payload: {
          playerId: "p2",
          placements: [
            {
              character: "MUMMY",
              zone: 1,
            },
            {
              character: "JIANGSHI",
              zone: 1,
            },
            {
              character: "MUMMY",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 13,
        eventType: "request_draw",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 14,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027063803,
        },
      },
      {
        sequenceNumber: 15,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 16,
        eventType: "place_coins",
        userId: "p3",
        payload: {
          playerId: "p3",
          placements: [
            {
              character: "ZOMBIE",
              zone: 1,
            },
            {
              character: "VAMPIRE",
              zone: 4,
            },
            {
              character: "ZOMBIE",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 17,
        eventType: "request_draw",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 18,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027064603,
        },
      },
      {
        sequenceNumber: 19,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 20,
        eventType: "place_coins",
        userId: "p1",
        payload: {
          playerId: "p1",
          placements: [
            {
              character: "GUMIHO",
              zone: 1,
            },
            {
              character: "MUMMY",
              zone: 1,
            },
            {
              character: "ZOMBIE",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 21,
        eventType: "request_draw",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 22,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027064703,
        },
      },
      {
        sequenceNumber: 23,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 24,
        eventType: "place_coins",
        userId: "p2",
        payload: {
          playerId: "p2",
          placements: [
            {
              character: "GUMIHO",
              zone: 1,
            },
            {
              character: "VAMPIRE",
              zone: 4,
            },
            {
              character: "VAMPIRE",
              zone: 4,
            },
          ],
        },
      },
      {
        sequenceNumber: 25,
        eventType: "request_draw",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 26,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027064803,
        },
      },
      {
        sequenceNumber: 27,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 28,
        eventType: "place_coins",
        userId: "p3",
        payload: {
          playerId: "p3",
          placements: [
            {
              character: "JIANGSHI",
              zone: 1,
            },
            {
              character: "GUMIHO",
              zone: 1,
            },
            {
              character: "ZOMBIE",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 29,
        eventType: "resolve_round",
        userId: "p1",
        payload: {
          resolverId: "p1",
        },
      },
      {
        sequenceNumber: 30,
        eventType: "confirm_round_recap",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 31,
        eventType: "confirm_round_recap",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 32,
        eventType: "confirm_round_recap",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 33,
        eventType: "advance_round",
        userId: "p1",
        payload: {
          resolverId: "p1",
        },
      },
      {
        sequenceNumber: 34,
        eventType: "request_draw",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 35,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027073603,
        },
      },
      {
        sequenceNumber: 36,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 37,
        eventType: "place_coins",
        userId: "p2",
        payload: {
          playerId: "p2",
          placements: [
            {
              character: "VAMPIRE",
              zone: 4,
            },
            {
              character: "GUMIHO",
              zone: 1,
            },
            {
              character: "ZOMBIE",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 38,
        eventType: "request_draw",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 39,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027073703,
        },
      },
      {
        sequenceNumber: 40,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 41,
        eventType: "place_coins",
        userId: "p3",
        payload: {
          playerId: "p3",
          placements: [
            {
              character: "ZOMBIE",
              zone: 1,
            },
            {
              character: "JIANGSHI",
              zone: 1,
            },
            {
              character: "JIANGSHI",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 42,
        eventType: "request_draw",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 43,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027073803,
        },
      },
      {
        sequenceNumber: 44,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 45,
        eventType: "place_coins",
        userId: "p1",
        payload: {
          playerId: "p1",
          placements: [
            {
              character: "VAMPIRE",
              zone: 4,
            },
            {
              character: "GUMIHO",
              zone: 1,
            },
            {
              character: "VAMPIRE",
              zone: 4,
            },
          ],
        },
      },
      {
        sequenceNumber: 46,
        eventType: "request_draw",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 47,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027074603,
        },
      },
      {
        sequenceNumber: 48,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 49,
        eventType: "place_coins",
        userId: "p2",
        payload: {
          playerId: "p2",
          placements: [
            {
              character: "GUMIHO",
              zone: 1,
            },
            {
              character: "MUMMY",
              zone: 1,
            },
            {
              character: "ZOMBIE",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 50,
        eventType: "request_draw",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 51,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027074703,
        },
      },
      {
        sequenceNumber: 52,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 53,
        eventType: "place_coins",
        userId: "p3",
        payload: {
          playerId: "p3",
          placements: [
            {
              character: "ZOMBIE",
              zone: 1,
            },
            {
              character: "MUMMY",
              zone: 1,
            },
            {
              character: "GUMIHO",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 54,
        eventType: "request_draw",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 55,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027074803,
        },
      },
      {
        sequenceNumber: 56,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 57,
        eventType: "place_coins",
        userId: "p1",
        payload: {
          playerId: "p1",
          placements: [
            {
              character: "MUMMY",
              zone: 1,
            },
            {
              character: "MUMMY",
              zone: 1,
            },
            {
              character: "JIANGSHI",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 58,
        eventType: "resolve_round",
        userId: "p1",
        payload: {
          resolverId: "p1",
        },
      },
      {
        sequenceNumber: 59,
        eventType: "confirm_round_recap",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 60,
        eventType: "confirm_round_recap",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 61,
        eventType: "confirm_round_recap",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 62,
        eventType: "advance_round",
        userId: "p1",
        payload: {
          resolverId: "p1",
        },
      },
      {
        sequenceNumber: 63,
        eventType: "request_draw",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 64,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027083603,
        },
      },
      {
        sequenceNumber: 65,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 66,
        eventType: "place_coins",
        userId: "p3",
        payload: {
          playerId: "p3",
          placements: [
            {
              character: "GUMIHO",
              zone: 1,
            },
            {
              character: "JIANGSHI",
              zone: 1,
            },
            {
              character: "VAMPIRE",
              zone: 4,
            },
          ],
        },
      },
      {
        sequenceNumber: 67,
        eventType: "request_draw",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 68,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027083703,
        },
      },
      {
        sequenceNumber: 69,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 70,
        eventType: "place_coins",
        userId: "p1",
        payload: {
          playerId: "p1",
          placements: [
            {
              character: "VAMPIRE",
              zone: 4,
            },
            {
              character: "MUMMY",
              zone: 1,
            },
            {
              character: "MUMMY",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 71,
        eventType: "request_draw",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 72,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027083803,
        },
      },
      {
        sequenceNumber: 73,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 74,
        eventType: "place_coins",
        userId: "p2",
        payload: {
          playerId: "p2",
          placements: [
            {
              character: "MUMMY",
              zone: 1,
            },
            {
              character: "VAMPIRE",
              zone: 4,
            },
            {
              character: "ZOMBIE",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 75,
        eventType: "request_draw",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 76,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027084603,
        },
      },
      {
        sequenceNumber: 77,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 78,
        eventType: "place_coins",
        userId: "p3",
        payload: {
          playerId: "p3",
          placements: [
            {
              character: "ZOMBIE",
              zone: 1,
            },
            {
              character: "MUMMY",
              zone: 1,
            },
            {
              character: "JIANGSHI",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 79,
        eventType: "request_draw",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 80,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027084703,
        },
      },
      {
        sequenceNumber: 81,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 82,
        eventType: "place_coins",
        userId: "p1",
        payload: {
          playerId: "p1",
          placements: [
            {
              character: "GUMIHO",
              zone: 1,
            },
            {
              character: "JIANGSHI",
              zone: 1,
            },
            {
              character: "GUMIHO",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 83,
        eventType: "request_draw",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 84,
        eventType: "shuffle_pool",
        userId: "p1",
        payload: {
          seed: 2027084803,
        },
      },
      {
        sequenceNumber: 85,
        eventType: "draw_coins",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 86,
        eventType: "place_coins",
        userId: "p2",
        payload: {
          playerId: "p2",
          placements: [
            {
              character: "JIANGSHI",
              zone: 1,
            },
            {
              character: "ZOMBIE",
              zone: 1,
            },
            {
              character: "ZOMBIE",
              zone: 1,
            },
          ],
        },
      },
      {
        sequenceNumber: 87,
        eventType: "resolve_round",
        userId: "p1",
        payload: {
          resolverId: "p1",
        },
      },
      {
        sequenceNumber: 88,
        eventType: "confirm_round_recap",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 89,
        eventType: "confirm_round_recap",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 90,
        eventType: "confirm_round_recap",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 91,
        eventType: "advance_round",
        userId: "p1",
        payload: {
          resolverId: "p1",
        },
      },
      {
        sequenceNumber: 92,
        eventType: "confirm_recap",
        userId: "p1",
        payload: {
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 93,
        eventType: "confirm_recap",
        userId: "p2",
        payload: {
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 94,
        eventType: "confirm_recap",
        userId: "p3",
        payload: {
          playerId: "p3",
        },
      },
      {
        sequenceNumber: 95,
        eventType: "score_race",
        userId: "p1",
        payload: {
          resolverId: "p1",
        },
      },
    ],
    notes: [
      "Live fixture includes request_draw identity events before host shuffle_pool/draw_coins.",
      "Secret character selections are private game data; observer replay must keep them hidden until RACE_SCORING.",
      "Final generated phase: GAME_OVER, race 1, round 3.",
    ],
  },
};
